import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { HttpHeaders } from '@angular/common/http';
import { ResponseUtils } from '../response-utils';

export const kymw08Handlers = [
    // 実績履歴取得 /kymw08/getResultList
    http.post(PlessService.SERVICE.KYMW0800GetResultList.url,
        async ({ request }) => {
            const req = await request.json();
            return HttpResponse.json(getResultList);
            // return ResponseUtils.getSysError();
            // return ResponseUtils.getSysE0100();
            // return ResponseUtils.getSys500();
        }
    ),
    // 計画数自動セット /kymw08/registPlanNum
    http.post(PlessService.SERVICE.KYMW0800RegistPlanNum.url,
        async ({ request }) => {
            const req = await request.json();
            console.log(PlessService.SERVICE.KYMW0800RegistPlanNum.url, req);
            return HttpResponse.json(registPlanNum);;
        }
    ),
];
const registPlanNum = {
    status: 'ok',
    message: '処理完了'
}
const getResultList = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            TotalNum: "3",
            StartDispNum: "1",
            EndDispNum: "100",
            SessionId: "aead6608-f29a-4a19-ba3c-249c18f36016",
            PublishResultData: [
                {
                    OrderCode: "3333333",
                    DelivCatalogId: "33333333",
                    MediumName: "ハビデリ",
                    MediumType: "001",
                    PCode: "P1111111",
                    Coop1: "0",
                    Coop2: "0",
                    Coop3: "0",
                    Coop4: "0",
                    Coop5: "0",
                    Coop6: "0",
                    Coop7: "0",
                    Coop8: "0",
                    PlanNumTotal: "800",
                    ResultPriceTotal: "72000",
                    ResultNumTotal: "720",
                    ResultPiTotal: "0",
                    DelivCatalogId1: "33333333",
                    DelivCatalogId2: "33333333",
                    DelivCatalogId3: "33333333",
                    DelivCatalogId4: "33333333",
                    DelivCatalogId5: "33333333",
                    DelivCatalogId6: "33333333",
                    DelivCatalogId7: "33333333",
                    DelivCatalogId8: "33333333",
                    ThisTimeSupplyTaxWithout1: "100",
                    ThisTimeSupplyTaxWithout2: "100",
                    ThisTimeSupplyTaxWithout3: "100",
                    ThisTimeSupplyTaxWithout4: "100",
                    ThisTimeSupplyTaxWithout5: "100",
                    ThisTimeSupplyTaxWithout6: "100",
                    ThisTimeSupplyTaxWithout7: "100",
                    ThisTimeSupplyTaxWithout8: "100",
                    ThisTimeCostPrice1: "10",
                    ThisTimeCostPrice2: "10",
                    ThisTimeCostPrice3: "10",
                    ThisTimeCostPrice4: "10",
                    ThisTimeCostPrice5: "10",
                    ThisTimeCostPrice6: "10",
                    ThisTimeCostPrice7: "10",
                    ThisTimeCostPrice8: "10",
                    PageNum1: "0",
                    PageNum2: "0",
                    PageNum3: "0",
                    PageNum4: "0",
                    PageNum5: "0",
                    PageNum6: "0",
                    PageNum7: "0",
                    PageNum8: "0",
                    PublishAmountLimitNum1: "0",
                    PublishAmountLimitNum2: "0",
                    PublishAmountLimitNum3: "0",
                    PublishAmountLimitNum4: "0",
                    PublishAmountLimitNum5: "0",
                    PublishAmountLimitNum6: "0",
                    PublishAmountLimitNum7: "0",
                    PublishAmountLimitNum8: "0",
                    PricePatternName1: "特価2",
                    PricePatternName2: "特価2",
                    PricePatternName3: "特価2",
                    PricePatternName4: "特価2",
                    PricePatternName5: "特価2",
                    PricePatternName6: "特価2",
                    PricePatternName7: "特価2",
                    PricePatternName8: "特価2",
                    AppearDivName1: "",
                    AppearDivName2: "",
                    AppearDivName3: "",
                    AppearDivName4: "",
                    AppearDivName5: "",
                    AppearDivName6: "",
                    AppearDivName7: "",
                    AppearDivName8: "",
                    PlanNum1: "100",
                    PlanNum2: "100",
                    PlanNum3: "100",
                    PlanNum4: "100",
                    PlanNum5: "100",
                    PlanNum6: "100",
                    PlanNum7: "100",
                    PlanNum8: "100",
                    ResultsAmount1: "9000",
                    ResultsAmount2: "9000",
                    ResultsAmount3: "9000",
                    ResultsAmount4: "9000",
                    ResultsAmount5: "9000",
                    ResultsAmount6: "9000",
                    ResultsAmount7: "9000",
                    ResultsAmount8: "9000",
                    ResultsNum1: "90",
                    ResultsNum2: "90",
                    ResultsNum3: "90",
                    ResultsNum4: "90",
                    ResultsNum5: "90",
                    ResultsNum6: "90",
                    ResultsNum7: "90",
                    ResultsNum8: "90",
                    NumPi1: "0",
                    NumPi2: "0",
                    NumPi3: "0",
                    NumPi4: "0",
                    NumPi5: "0",
                    NumPi6: "0",
                    NumPi7: "0",
                    NumPi8: "0",
                    UsedNum1: "90",
                    UsedNum2: "90",
                    UsedNum3: "90",
                    UsedNum4: "90",
                    UsedNum5: "90",
                    UsedNum6: "90",
                    UsedNum7: "90",
                    UsedNum8: "90",
                }, {
                    OrderCode: "2222222",
                    DelivCatalogId: "22222222",
                    MediumName: "ハビデリ",
                    MediumType: "001",
                    PCode: "P1111111",
                    Coop1: "◎0",
                    Coop2: "◎0",
                    Coop3: "◎0",
                    Coop4: "◎0",
                    Coop5: "◎0",
                    Coop6: "◎0",
                    Coop7: "◎0",
                    Coop8: "◎0",
                    PlanNumTotal: "1600",
                    ResultPriceTotal: "240000",
                    ResultNumTotal: "1200",
                    ResultPiTotal: "0",
                    DelivCatalogId1: "22222222",
                    DelivCatalogId2: "22222222",
                    DelivCatalogId3: "22222222",
                    DelivCatalogId4: "22222222",
                    DelivCatalogId5: "22222222",
                    DelivCatalogId6: "22222222",
                    DelivCatalogId7: "22222222",
                    DelivCatalogId8: "22222222",
                    ThisTimeSupplyTaxWithout1: "200",
                    ThisTimeSupplyTaxWithout2: "200",
                    ThisTimeSupplyTaxWithout3: "200",
                    ThisTimeSupplyTaxWithout4: "200",
                    ThisTimeSupplyTaxWithout5: "200",
                    ThisTimeSupplyTaxWithout6: "200",
                    ThisTimeSupplyTaxWithout7: "200",
                    ThisTimeSupplyTaxWithout8: "200",
                    ThisTimeCostPrice1: "20",
                    ThisTimeCostPrice2: "20",
                    ThisTimeCostPrice3: "20",
                    ThisTimeCostPrice4: "20",
                    ThisTimeCostPrice5: "20",
                    ThisTimeCostPrice6: "20",
                    ThisTimeCostPrice7: "20",
                    ThisTimeCostPrice8: "20",
                    PageNum1: "20",
                    PageNum2: "20",
                    PageNum3: "20",
                    PageNum4: "20",
                    PageNum5: "20",
                    PageNum6: "20",
                    PageNum7: "20",
                    PageNum8: "20",
                    PublishAmountLimitNum1: "2",
                    PublishAmountLimitNum2: "2",
                    PublishAmountLimitNum3: "2",
                    PublishAmountLimitNum4: "2",
                    PublishAmountLimitNum5: "2",
                    PublishAmountLimitNum6: "2",
                    PublishAmountLimitNum7: "2",
                    PublishAmountLimitNum8: "2",
                    PricePatternName1: "特価1",
                    PricePatternName2: "特価1",
                    PricePatternName3: "特価1",
                    PricePatternName4: "特価1",
                    PricePatternName5: "特価1",
                    PricePatternName6: "特価1",
                    PricePatternName7: "特価1",
                    PricePatternName8: "特価1",
                    AppearDivName1: "",
                    AppearDivName2: "",
                    AppearDivName3: "",
                    AppearDivName4: "",
                    AppearDivName5: "",
                    AppearDivName6: "",
                    AppearDivName7: "",
                    AppearDivName8: "",
                    PlanNum1: "200",
                    PlanNum2: "200",
                    PlanNum3: "200",
                    PlanNum4: "200",
                    PlanNum5: "200",
                    PlanNum6: "200",
                    PlanNum7: "200",
                    PlanNum8: "200",
                    ResultsAmount1: "30000",
                    ResultsAmount2: "30000",
                    ResultsAmount3: "30000",
                    ResultsAmount4: "30000",
                    ResultsAmount5: "30000",
                    ResultsAmount6: "30000",
                    ResultsAmount7: "30000",
                    ResultsAmount8: "30000",
                    ResultsNum1: "150",
                    ResultsNum2: "150",
                    ResultsNum3: "150",
                    ResultsNum4: "150",
                    ResultsNum5: "150",
                    ResultsNum6: "150",
                    ResultsNum7: "150",
                    ResultsNum8: "150",
                    NumPi1: "0",
                    NumPi2: "0",
                    NumPi3: "0",
                    NumPi4: "0",
                    NumPi5: "0",
                    NumPi6: "0",
                    NumPi7: "0",
                    NumPi8: "0",
                    UsedNum1: "150",
                    UsedNum2: "150",
                    UsedNum3: "150",
                    UsedNum4: "150",
                    UsedNum5: "150",
                    UsedNum6: "150",
                    UsedNum7: "150",
                    UsedNum8: "150",
                }, {
                    OrderCode: "1111111",
                    DelivCatalogId: "11111111",
                    MediumName: "ハビデリ",
                    MediumType: "001",
                    PCode: "P1111111",
                    Coop1: "0.3",
                    Coop2: "11.3",
                    Coop3: "16.6",
                    Coop4: "0.7",
                    Coop5: "25.5",
                    Coop6: "24.6",
                    Coop7: "0.3",
                    Coop8: "0.3",
                    PlanNumTotal: "2400",
                    ResultPriceTotal: "450000",
                    ResultNumTotal: "1200",
                    ResultPiTotal: "12.6",
                    DelivCatalogId1: "11111111",
                    DelivCatalogId2: "11111111",
                    DelivCatalogId3: "11111111",
                    DelivCatalogId4: "11111111",
                    DelivCatalogId5: "11111111",
                    DelivCatalogId6: "11111111",
                    DelivCatalogId7: "11111111",
                    DelivCatalogId8: "11111111",
                    ThisTimeSupplyTaxWithout1: "300",
                    ThisTimeSupplyTaxWithout2: "300",
                    ThisTimeSupplyTaxWithout3: "300",
                    ThisTimeSupplyTaxWithout4: "300",
                    ThisTimeSupplyTaxWithout5: "300",
                    ThisTimeSupplyTaxWithout6: "300",
                    ThisTimeSupplyTaxWithout7: "300",
                    ThisTimeSupplyTaxWithout8: "300",
                    ThisTimeCostPrice1: "30",
                    ThisTimeCostPrice2: "30",
                    ThisTimeCostPrice3: "30",
                    ThisTimeCostPrice4: "30",
                    ThisTimeCostPrice5: "30",
                    ThisTimeCostPrice6: "30",
                    ThisTimeCostPrice7: "30",
                    ThisTimeCostPrice8: "30",
                    PageNum1: "30",
                    PageNum2: "30",
                    PageNum3: "30",
                    PageNum4: "30",
                    PageNum5: "30",
                    PageNum6: "30",
                    PageNum7: "30",
                    PageNum8: "30",
                    PublishAmountLimitNum1: "3",
                    PublishAmountLimitNum2: "3",
                    PublishAmountLimitNum3: "3",
                    PublishAmountLimitNum4: "3",
                    PublishAmountLimitNum5: "3",
                    PublishAmountLimitNum6: "3",
                    PublishAmountLimitNum7: "3",
                    PublishAmountLimitNum8: "3",
                    PricePatternName1: "通常",
                    PricePatternName2: "通常",
                    PricePatternName3: "通常",
                    PricePatternName4: "通常",
                    PricePatternName5: "通常",
                    PricePatternName6: "通常",
                    PricePatternName7: "通常",
                    PricePatternName8: "通常",
                    AppearDivName1: "初登場",
                    AppearDivName2: "初登場",
                    AppearDivName3: "初登場",
                    AppearDivName4: "初登場",
                    AppearDivName5: "初登場",
                    AppearDivName6: "初登場",
                    AppearDivName7: "初登場",
                    AppearDivName8: "初登場",
                    PlanNum1: "300",
                    PlanNum2: "300",
                    PlanNum3: "300",
                    PlanNum4: "300",
                    PlanNum5: "300",
                    PlanNum6: "300",
                    PlanNum7: "300",
                    PlanNum8: "300",
                    ResultsAmount1: "45000",
                    ResultsAmount2: "45000",
                    ResultsAmount3: "45000",
                    ResultsAmount4: "45000",
                    ResultsAmount5: "45000",
                    ResultsAmount6: "45000",
                    ResultsAmount7: "45000",
                    ResultsAmount8: "45000",
                    ResultsNum1: "150",
                    ResultsNum2: "150",
                    ResultsNum3: "150",
                    ResultsNum4: "150",
                    ResultsNum5: "150",
                    ResultsNum6: "150",
                    ResultsNum7: "150",
                    ResultsNum8: "150",
                    NumPi1: "0.3",
                    NumPi2: "11.3",
                    NumPi3: "16.6",
                    NumPi4: "0.7",
                    NumPi5: "25.5",
                    NumPi6: "24.6",
                    NumPi7: "0.3",
                    NumPi8: "0.3",
                    UsedNum1: "150",
                    UsedNum2: "150",
                    UsedNum3: "150",
                    UsedNum4: "150",
                    UsedNum5: "150",
                    UsedNum6: "150",
                    UsedNum7: "150",
                    UsedNum8: "150",
                },
            ],
        },
    },
};